import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi, { axiosApiNoInterceptors } from "~/api/axiosApi.ts";
import type { AuthenticatedUser, LoginData, LoginResponse } from "~/features/auth/api/auth/authTypes.ts";

const authBasePath = "auth/";

export const getAuthenticatedUser = (): AxiosApiResponsePromise<AuthenticatedUser> => axiosApi.get("user");

export const login = (data: LoginData): AxiosApiResponsePromise<LoginResponse> =>
    axiosApiNoInterceptors.post(authBasePath + "login", data);

export const logout = (): AxiosApiResponsePromise<void> => axiosApi.post(authBasePath + "logout");

export const requestPasswordReset = (email: string): AxiosApiResponsePromise<void> =>
    axiosApiNoInterceptors.post("users/password-reset", { email });

export const setPassword = (token: string, password: string): AxiosApiResponsePromise<void> =>
    axiosApiNoInterceptors.patch("users/password", { token, password });

export const validatePasswordResetToken = (token: string): AxiosApiResponsePromise<void> =>
    axiosApiNoInterceptors.get(`users/password-reset/${token}`);

export const validateInvitationToken = (token: string): AxiosApiResponsePromise<void> =>
    axiosApiNoInterceptors.get(`users/registration/${token}`);

export const registerUser = (data: {
    firstName: string;
    lastName: string;
    nickname: string | null;
    password: string;
    token: string;
}): AxiosApiResponsePromise<void> => {
    return axiosApiNoInterceptors.post("users/registration", data);
};

export const updatePersonalDetails = (data: {
    firstName: string;
    lastName: string;
    nickname: string | null;
}): AxiosApiResponsePromise<void> => {
    return axiosApi.patch("user/personal-details", data);
};

export function uploadAvatarImage(formData: FormData): AxiosApiResponsePromise<void> {
    return axiosApi.post("user/avatar-image", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}

export function deleteAvatarImage(): AxiosApiResponsePromise<void> {
    return axiosApi.delete("user/avatar-image");
}

export function indexPendingFriendshipRequests(): AxiosApiResponsePromise<number> {
    return axiosApi.get("user/friendships/pending");
}
